import { createTheme } from '@mui/material/styles'
const defaultTheme = createTheme()

// Define here our shadows to override default theme shadows
export const customShadows = [
  'none',
  '0px 1px 4px rgba(0, 0, 0, 0.2)',
  '0px 2px 8px rgba(0, 0, 0, 0.2)',
]

// Replaces theme default shadows with defined custom shadows
const shadows = defaultTheme.shadows.map((_, index) => {
  return customShadows[index] ? customShadows[index] : 'none'
})

export default shadows
